import { sanitize } from '@superbet-group/web.lib.vue-utilities';
import { defineComponent } from '@vue/composition-api';

var script = defineComponent({
    name: 'SanitizedHtml',
    props: {
        content: {
            type: String,
            required: true,
        },
        tagWhitelist: {
            type: Array,
            required: false,
        },
        attributeWhitelist: {
            type: Array,
            required: false,
        },
        tagBlacklist: {
            type: Array,
            required: false
        }
    },
    mounted: function () {
        this.$emit('created', this.$refs['content']);
    },
    updated: function () {
        this.$emit('rendered');
    },
    computed: {
        sanitizedContent: function () {
            return sanitize(this.content, {
                tagWhitelist: this.tagWhitelist,
                attributeWhitelist: this.attributeWhitelist,
                tagBlacklist: this.tagBlacklist
            });
        },
    },
});

export default script;
